"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7501],{

/***/ 15381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MenuIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98547);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63319);
/* harmony import */ var _styles_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71467);






var MenuIcon = function(param) {
    var dataTest = param.dataTest, onClick = param.onClick, svgSrc = param.svgSrc, _visible = param.visible, visible = _visible === void 0 ? true : _visible, textOverlay = param.textOverlay, _iconWidth = param.iconWidth, iconWidth = _iconWidth === void 0 ? "1.438rem" : _iconWidth;
    /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Center */ .M5, {
        "data-test": dataTest,
        onClick: function() {
            return onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        cursor: "pointer",
        paddingRight: {
            base: "1rem",
            xl: "0.5rem"
        },
        display: visible ? "block" : "none",
        _last: {
            paddingRight: 0
        },
        height: "100%",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Center */ .M5, {
            position: "relative",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_svg__WEBPACK_IMPORTED_MODULE_1__/* .ReactSVG */ .Q, {
                    src: svgSrc,
                    style: {
                        width: iconWidth
                    }
                }),
                textOverlay && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    top: "2px",
                    left: 0,
                    display: "inline-block",
                    width: {
                        base: "15px",
                        xl: "18px"
                    },
                    height: {
                        base: "15px",
                        xl: "18px"
                    },
                    borderRadius: "50%",
                    margin: "0 auto",
                    backgroundColor: _styles__WEBPACK_IMPORTED_MODULE_2__/* .defaultTheme.colors.primary[500] */ .uH.colors.primary[500],
                    color: _styles__WEBPACK_IMPORTED_MODULE_2__/* .defaultTheme.colors.white */ .uH.colors.white,
                    fontSize: {
                        base: _styles_constants__WEBPACK_IMPORTED_MODULE_3__/* .labelFontSize */ .tz,
                        xl: _styles_constants__WEBPACK_IMPORTED_MODULE_3__/* .smallFontSize */ .oD
                    },
                    lineHeight: {
                        base: "15px",
                        xl: "18px"
                    },
                    textAlign: "center",
                    children: textOverlay
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MenuIcon);


/***/ }),

/***/ 77501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MenuIcon": function() { return /* reexport safe */ _MenuIcon__WEBPACK_IMPORTED_MODULE_0__.O; }
/* harmony export */ });
/* harmony import */ var _MenuIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15381);



/***/ })

}]);